var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      attrs: {
        "grid-list-md": "",
        fluid: "",
        "px-0": "",
        "py-0": "",
        id: "search-container",
      },
    },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", "pa-0": "" } },
            [
              _c(
                "v-parallax",
                {
                  attrs: {
                    height: _vm.windowHeight,
                    src: require("./assets/bg-bg.png"),
                    dark: "",
                  },
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "marv-bg-fg",
                      attrs: { align: "center", justify: "center" },
                    },
                    [
                      _c(
                        "v-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c(
                            "h1",
                            { staticClass: "text-h4 font-weight-thin mb-4" },
                            [
                              _vm._v(
                                "\n                                AFESM Clusters\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("h4", { staticClass: "subheading" }, [
                            _vm._v(
                              "\n                                Investigate the "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "https://foldseek.com",
                                  target: "_blank",
                                  rel: "noopener",
                                },
                              },
                              [_vm._v("Foldseek")]
                            ),
                            _vm._v(" clustered AFESM ("),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "https://alphafold.ebi.ac.uk",
                                  target: "_blank",
                                  rel: "noopener",
                                },
                              },
                              [_vm._v("AlphaFold")]
                            ),
                            _vm._v(" + "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "https://esmatlas.com/",
                                  target: "_blank",
                                  rel: "noopener",
                                },
                              },
                              [_vm._v("ESMatlas")]
                            ),
                            _vm._v(") database\n                            "),
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "v-tabs",
                            {
                              staticClass: "search-select",
                              attrs: {
                                "slider-size": "1",
                                centered: "",
                                "background-color": "transparent",
                                dark: "",
                              },
                              model: {
                                value: _vm.tab,
                                callback: function ($$v) {
                                  _vm.tab = $$v
                                },
                                expression: "tab",
                              },
                            },
                            [
                              _c("v-tab", [_vm._v("Uniprot, MGnify")]),
                              _vm._v(" "),
                              _c("v-tab", [_vm._v("Biome")]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tabs-items",
                            {
                              staticStyle: { padding: "0.5em" },
                              model: {
                                value: _vm.tab,
                                callback: function ($$v) {
                                  _vm.tab = $$v
                                },
                                expression: "tab",
                              },
                            },
                            [
                              _c(
                                "v-tab-item",
                                [
                                  _c("v-text-field", {
                                    staticStyle: {
                                      "max-width": "400px",
                                      margin: "0 auto",
                                    },
                                    attrs: {
                                      outlined: "",
                                      label: "Accession",
                                      "append-icon": _vm.inSearch
                                        ? _vm.$MDI.ProgressWrench
                                        : _vm.$MDI.Magnify,
                                      disabled: _vm.inSearch,
                                      error: _vm.error != null,
                                      "error-messages": _vm.error
                                        ? _vm.error
                                        : [],
                                      dark: "",
                                    },
                                    on: {
                                      "click:append": _vm.search,
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.search.apply(null, arguments)
                                      },
                                      change: function ($event) {
                                        _vm.selectedExample = null
                                      },
                                      keydown: function ($event) {
                                        _vm.error = null
                                      },
                                    },
                                    model: {
                                      value: _vm.query,
                                      callback: function ($$v) {
                                        _vm.query = $$v
                                      },
                                      expression: "query",
                                    },
                                  }),
                                  _vm._v(" "),
                                  [
                                    _c("h2", { staticClass: "text-h6 mb-2" }, [
                                      _vm._v(
                                        "\n                                            Examples\n                                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-chip-group",
                                      {
                                        staticStyle: {
                                          "max-width": "500px",
                                          margin: "0 auto",
                                        },
                                        attrs: { column: "", dark: "" },
                                        model: {
                                          value: _vm.selectedExample,
                                          callback: function ($$v) {
                                            _vm.selectedExample = $$v
                                          },
                                          expression: "selectedExample",
                                        },
                                      },
                                      _vm._l(_vm.examples, function (item) {
                                        return _c(
                                          "v-chip",
                                          {
                                            key: item.id,
                                            attrs: { outlined: "" },
                                            on: {
                                              click: function ($event) {
                                                _vm.query = item.id
                                              },
                                            },
                                          },
                                          [
                                            _c("b", [_vm._v(_vm._s(item.id))]),
                                            _vm._v(
                                              "   " +
                                                _vm._s(item.desc) +
                                                "\n                                            "
                                            ),
                                          ]
                                        )
                                      }),
                                      1
                                    ),
                                  ],
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tab-item",
                                [
                                  _c("BiomeSearch", {
                                    attrs: {
                                      "append-icon": _vm.inSearch
                                        ? _vm.$MDI.ProgressWrench
                                        : _vm.$MDI.Magnify,
                                      value: _vm.queryBiome
                                        ? _vm.queryBiome.text +
                                          " (" +
                                          _vm.queryBiome.value +
                                          ")"
                                        : "",
                                    },
                                    on: {
                                      "click:append": _vm.searchBiome,
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.searchBiome.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.queryBiome,
                                      callback: function ($$v) {
                                        _vm.queryBiome = $$v
                                      },
                                      expression: "queryBiome",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-radio-group",
                                    {
                                      staticStyle: {
                                        "max-width": "400px",
                                        margin: "0 auto",
                                      },
                                      attrs: { inline: "" },
                                      model: {
                                        value: _vm.biomeSearchType,
                                        callback: function ($$v) {
                                          _vm.biomeSearchType = $$v
                                        },
                                        expression: "biomeSearchType",
                                      },
                                    },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          name: "biomeSearchType",
                                          label: "Include lower Biome lineage",
                                          value: "lower",
                                          dark: "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("v-radio", {
                                        attrs: {
                                          name: "biomeSearchType",
                                          label: "Exact Biome",
                                          value: "exact",
                                          dark: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tab-item",
                                [
                                  _c("FoldseekSearchButton", {
                                    attrs: { dark: "" },
                                    on: {
                                      response: function ($event) {
                                        return _vm.searchFoldseek($event)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.tab == 1
            ? _c("BiomeSearchResult", {
                on: {
                  total: function ($event) {
                    _vm.small = $event > 0
                    _vm.inSearch = false
                  },
                },
              })
            : _vm.tab == 2
            ? _c("FoldseekSearchResult", {
                on: {
                  total: function ($event) {
                    _vm.small = $event > 0
                    _vm.inSearch = false
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c(
                "v-card",
                { attrs: { rounded: "0" } },
                [
                  _c(
                    "v-flex",
                    [
                      _c(
                        "v-card-title",
                        {
                          staticClass: "pb-0 mb-0",
                          attrs: { "primary-title": "" },
                        },
                        [
                          _c("div", { staticClass: "text-h5 mb-0" }, [
                            _vm._v("Reference"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-title",
                        {
                          staticClass: "pt-0 mt-0",
                          attrs: { "primary-title": "" },
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "text-subtitle-1 mb-0",
                              staticStyle: { "word-break": "break-word" },
                            },
                            [
                              _vm._v(
                                "\n                            Yeo J, Han Y, Bordin N, Lau AM, Kandathil SM, Kim H, Karin EL, Mirdita M, Jones DT, Orengo C, Steinegger M. \n"
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://www.biorxiv.org/content/10.1101/2025.04.23.650224v1",
                                    target: "_blank",
                                    rel: "noopener",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\nMetagenomic-scale analysis of the predicted protein structure universe."
                                  ),
                                ]
                              ),
                              _vm._v(
                                " \nbioRxiv, 2025.\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }